export enum Role {
  Admin = 'Admin',
  Doctor = 'Employee',
  Patient = 'Patient',
  TenantAdmin = 'TenantAdmin',
}
